
<template>
    <div>
        <div class="information_input margin-top1">
            <div class="information_Title">五大亮点</div>
            <div class="input_el input_span">
                <div style="width:92%;float: left;">
                    <el-input
                        type="textarea"
                        class="width97"
                        autosize
                        placeholder="五大亮点长度不超过500个字符"
                        v-model="brightSpot1"
                        maxlength="500"
                        show-word-limit
                        style="padding: 0px 0 10px 0;"
                    ></el-input>
                    <el-input
                        type="textarea"
                        class="width97"
                        autosize
                        placeholder="五大亮点长度不超过500个字符"
                        v-model="brightSpot2"
                        maxlength="500"
                        show-word-limit
                        style="padding: 0px 0 10px 0;"
                    ></el-input>
                    <el-input
                        type="textarea"
                        class="width97"
                        autosize
                        placeholder="五大亮点长度不超过500个字符"
                        v-model="brightSpot3"
                        maxlength="500"
                        show-word-limit
                        style="padding: 0px 0 10px 0;"
                    ></el-input>
                    <div>
                        <span style="line-height: 50px;">A段： &nbsp;</span>
                        <el-input
                            type="textarea"
                            autosize
                            placeholder="五大亮点长度不超过500个字符"
                            v-model="brightSpot4"
                            maxlength="500"
                            show-word-limit
                            style="padding: 0px 0 10px 0;width:90%"
                        ></el-input>
                    </div>
                    <div>
                        <span style="line-height: 50px;">B段： &nbsp;</span>
                        <el-input
                            type="textarea"
                            autosize
                            placeholder="五大亮点长度不超过500个字符"
                            v-model="brightSpot5"
                            maxlength="500"
                            show-word-limit
                            style="padding: 0px 0 10px 0;width:90%;"
                        ></el-input>
                    </div>
                </div>
                <div style="float: right;">
                    <el-button type="primary" @click="addBright">生成亮点</el-button>
                </div>
            </div>
            <div class="information_tips">五大亮点注意 ：(最后两个亮点多个值用双逗号隔开比如:[a,,b,,c])</div>
            <div class="titlelist" v-show="generatebright_spot">
                <div class="Minister-top-top informationbackground">
                    <div
                        class="Minister-top-right Minister-top-color"
                        @click="keywordClick"
                    >{{variantkeyword}}</div>
                </div>
                <el-table
                    v-show="keywordtypt"
                    ref="multipleTable"
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 100%;padding: 0 0 0 10px;"
                    @selection-change="keywordChange"
                >
                    <el-table-column type="selection" width="20"></el-table-column>
                    <el-table-column label="全部" width="50"></el-table-column>
                    <el-table-column label="A段亮点">
                        <template slot-scope="scope">
                            <el-input
                                v-model="scope.row.nameelement"
                                @change="dataChange"
                                style="width:80%"
                            ></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="B段亮点">
                        <template slot-scope="scope">
                            <el-input
                                v-model="scope.row.nameitem"
                                @change="dataChange"
                                style="width:80%"
                            ></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" label="亮点的相似度" width="100">
                        <template slot-scope="scope">
                            <span>{{scope.row.val}}%</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "bright_spot",
    data() {
        return {
            //  五大亮度
            brightSpot1: "",
            brightSpot2: "",
            brightSpot3: "",
            brightSpot4: "",
            brightSpot5: "",
            generatebright_spot: false,
            tableData: [],
            keywordtypt: true,
            variantkeyword: "收起"
        };
    },
    mounted() {},
    created() {},
    methods: {
        keywordClick() {
            this.keywordtypt = !this.keywordtypt;
            if (this.variantkeyword === "展开") {
                this.variantkeyword = "收起";
            } else {
                this.variantkeyword = "展开";
            }
        },
        // 生成亮点
        addBright() {
            const chineseEnglish1 = this.brightSpot4.replace(/，，/gi, ",,");
            const chineseEnglish2 = this.brightSpot5.replace(/，，/gi, ",,");
            let brightSpot4 = chineseEnglish1.split(",,");
            let brightSpot5 = chineseEnglish2.split(",,");
            brightSpot4.forEach(element => {
                brightSpot5.forEach(item => {
                    var param = {
                        nameelement: `${element}`,
                        nameitem: `${item}`,
                        val: 0
                    };
                    this.tableData.push(param);
                });
            });
            console.log(this.tableData)
            this.titleSimilarity(); // 设置名称相似度
        },
        titleSimilarity() {
            let str = "";
            this.tableData.forEach((item, index) => {
                if (index == 0) {
                    item.val = 100;
                    str = this.tableData[0].nameelement;
                } else {
                    if (str.includes(item.nameitem)) {
                        item.val += 50;
                    }
                    if (str.includes(item.nameelement)) {
                        item.val += 50;
                    }
                }
            });
            this.setSort(); //从小到大的排序
            this.generatebright_spot = true;
            this.toggleSelection(); // 设置全选
        },
        setSort() {
            const arr = this.tableData;
            var min;
            var arrname;
            var namei;
            for (let i = 1; i < arr.length; i++) {
                for (var j = i; j < arr.length; j++) {
                    if (arr[i].val > arr[j].val) {
                        min = arr[j].val;
                        arr[j].val = arr[i].val;
                        arr[i].val = min;

                        arrname = arr[j].nameelement;
                        arr[j].nameelement = arr[i].nameelement;
                        arr[i].nameelement = arrname;

                        namei = arr[j].nameitem;
                        arr[j].nameitem = arr[i].nameitem;
                        arr[i].nameitem = namei;
                    }
                }
            }
        },
        toggleSelection() {
            this.tableData.forEach(row => {
                this.$refs.multipleTable.toggleRowSelection(row);
            });
        },
        // 标题选中按钮
        titleChange(val) {
            //  console.log(val)
        },
        // 标题展开
        contentClick() {
            this.varianttypt = !this.varianttypt;
            if (this.variantcontent === "展开") {
                this.variantcontent = "收起";
            } else {
                this.variantcontent = "展开";
            }
        },
        // 标题列表修改
        dataChange(val) {
            console.log(val);
        },
        keywordChange(val) {
            console.log(val);
        }
    }
};
</script>

<style lang="scss" scoped>
/deep/ {
    .width97 .el-textarea__inner:focus{
        outline: 0;
        border-color: #cce198;
    }
    .el-textarea__inner:focus{
        outline: 0;
        border-color: #cce198;
    }
}
</style>